<template>
  <!-- 订单详情 -->
  <div class="orderDetails" v-if="dialogVisible">
    <el-dialog
      width="92%"
      custom-class="order-dialog"
      :visible.sync="dialogVisible"
      @close="$emit('update:visible', false)"
    >
      <div slot="title" class="order-dialog__title">
        <div class="order-dialog__title-main">
          <i
            v-if="detailsData.backStatus == 1"
            class="iconfont icon-fan order-dialog__back-icon"
          ></i>
          <i
            v-if="detailsData.refundType == 1"
            class="iconfont icon-tuiyuan order-dialog__refund-icon"
          ></i>
          <span class="order-dialog__sn">{{
            detailsData.orderSn || "门店订单衣物详情"
          }}</span>
          <el-tag
            v-if="detailsData.status != null && detailsData.status !== ''"
            size="small"
            effect="plain"
          >
            {{ orderStatus(detailsData.status) }}
          </el-tag>
          <el-tag
            v-if="detailsData.channelName"
            size="small"
            type="info"
            effect="plain"
          >
            {{ detailsData.channelName }}
          </el-tag>
          <el-tag
            v-if="detailsData.stageName"
            size="small"
            type="success"
            effect="plain"
          >
            {{ detailsData.stageName }}
          </el-tag>
        </div>
      </div>

      <div class="order-detail-body">
        <div class="order-summary">
          <div class="order-summary__item">
            <span class="order-summary__label">微信支付 / 余额支付</span>
            <span class="order-summary__value order-summary__value--primary">
              ¥{{ detailsData.wxAmount != null ? detailsData.wxAmount : "0.00" }}
              /
              ¥{{
                detailsData.balancelAmount != null
                  ? detailsData.balancelAmount
                  : "0.00"
              }}
            </span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">订单总数量</span>
            <span class="order-summary__value"
              >{{ detailsData.totalQuantity != null ? detailsData.totalQuantity : 0 }} 件</span
            >
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">顾客姓名</span>
            <span class="order-summary__value">{{
              detailsData.senderName || "-"
            }}</span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">用户号码</span>
            <span class="order-summary__value">{{
              detailsData.senderPhone || "-"
            }}</span>
          </div>
        </div>

        <div class="detail-cards">
          <section class="detail-section">
            <div class="detail-section__head">
              <i class="el-icon-document detail-section__icon"></i>
              <h3 class="detail-section__title">订单信息</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="2" size="small" border>
                <el-descriptions-item label="父订单编号">
                  <span
                    v-if="detailsData.orderSnParent"
                    class="link-sn"
                    @click="openParentOrderDetail"
                    >{{ detailsData.orderSnParent }}</span
                  >
                  <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="支付单号">
                  {{ detailsData.paySn || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="支付方式">
                  <el-tag
                    type="warning"
                    size="mini"
                    v-if="detailsData.payType == '2'"
                    >其他支付</el-tag
                  >
                  <el-tag
                    type="success"
                    size="mini"
                    v-else-if="detailsData.payType == '1'"
                    >微信</el-tag
                  >
                  <el-tag
                    type="danger"
                    size="mini"
                    v-else-if="detailsData.payType == '0'"
                    >未支付</el-tag
                  >
                  <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="下单时间">
                  {{ detailsData.payTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item
                  v-if="detailsData.backStatus"
                  label="返洗关联主单"
                >
                  <span class="text-danger">{{
                    detailsData.parentOrderSn || "-"
                  }}</span>
                </el-descriptions-item>
                <el-descriptions-item
                  label="订单备注"
                  :span="detailsData.backStatus ? 1 : 2"
                >
                  <el-tooltip
                    v-if="detailsData.note"
                    :content="detailsData.note"
                    placement="top"
                    effect="dark"
                    :disabled="isContentShort(detailsData.note)"
                  >
                    <div class="ellipsis">{{ detailsData.note }}</div>
                  </el-tooltip>
                  <span v-else>-</span>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <section class="detail-section">
            <div class="detail-section__head">
              <i
                class="el-icon-money detail-section__icon detail-section__icon--money"
              ></i>
              <h3 class="detail-section__title">金额明细</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="2" size="small" border>
                <el-descriptions-item label="微信支付">
                  {{ detailsData.wxAmount != null ? detailsData.wxAmount : 0 }}
                </el-descriptions-item>
                <el-descriptions-item label="余额支付">
                  {{
                    detailsData.balancelAmount != null
                      ? detailsData.balancelAmount
                      : 0
                  }}
                </el-descriptions-item>
                <el-descriptions-item label="平均金额">
                  {{ detailsData.payAmount != null ? detailsData.payAmount : 0 }}
                </el-descriptions-item>
                <el-descriptions-item label="市场金额">
                  {{
                    detailsData.originalAmount != null
                      ? detailsData.originalAmount
                      : 0
                  }}
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <section class="detail-section detail-section--full">
            <div class="detail-section__head">
              <i
                class="el-icon-s-goods detail-section__icon detail-section__icon--cloth"
              ></i>
              <h3 class="detail-section__title">衣物信息</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="3" size="small" border>
                <el-descriptions-item label="水洗码">
                  {{ detailsData.washingCode || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="名称">
                  {{ detailsData.productName || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="附件">
                  {{ detailsData.productAnnex || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="瑕疵">
                  {{ detailsData.productFlaw || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="格架">
                  {{ detailsData.grillage || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="附格架">
                  {{ detailsData.annexGrillage || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="格架备注" :span="3">
                  {{ detailsData.grillageRemark || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="衣物图片" :span="3">
                  <div class="cloth-imgs">
                    <ul v-if="imageList.length" class="cloth-imgs__list">
                      <li
                        v-for="(item, index) in imageList"
                        :key="index"
                        class="cloth-imgs__item"
                        @click="showImage(index)"
                      >
                        <img :src="item" alt="衣物图片" />
                      </li>
                    </ul>
                    <span v-else class="cloth-imgs__empty">暂无图片</span>
                  </div>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <section class="detail-section detail-section--full">
            <div class="detail-section__head">
              <i
                class="el-icon-truck detail-section__icon detail-section__icon--logistics"
              ></i>
              <h3 class="detail-section__title">生产流转</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="3" size="small" border>
                <el-descriptions-item label="门店收衣">
                  {{ detailsData.storeClothesTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="取衣司机">
                  {{ detailsData.tcDriverName || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="取衣时间">
                  {{ detailsData.takeClothesTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="分检员">
                  {{ detailsData.sortingUserName || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="分检时间">
                  {{ detailsData.sortingTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="总检员">
                  {{ detailsData.giUserName || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="总检时间">
                  {{ detailsData.totalSelectionTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="出厂时间">
                  {{ detailsData.exFactoryTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="送衣司机">
                  {{ detailsData.scDriverName || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="送衣时间">
                  {{ detailsData.sendingClothesTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="净衣入库">
                  {{ detailsData.cleanClothesTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="取衣交付">
                  {{ detailsData.deliveryClothesTime || "-" }}
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>
        </div>

        <div class="detail-btn">
          <el-button
            v-if="Number(detailsData.status) < 9"
            @click="handleDelete(detailsData)"
            type="danger"
            size="small"
            >删单</el-button
          >
          <el-button
            v-if="Number(detailsData.status) < 9"
            @click="handleCompleted(detailsData)"
            type="success"
            size="small"
            >提前完成订单</el-button
          >
          <el-button
            v-if="
              Number(detailsData.status) >= 5 && Number(detailsData.status) < 9
            "
            @click="handleCancelGiBy(detailsData)"
            type="text"
            class="btn-danger-text"
            >取消总检</el-button
          >
          <el-button
            v-if="
              Number(detailsData.status) >= 4 &&
              Number(detailsData.status) <= 9
            "
            @click="handleWashCode(detailsData)"
            type="text"
            >主水洗码</el-button
          >
          <el-button
            v-if="
              Number(detailsData.status) >= 4 &&
              Number(detailsData.status) <= 9 &&
              detailsData.productAnnex
            "
            @click="handleAnnexCode(detailsData)"
            type="text"
            >附水洗码</el-button
          >
          <el-button
            v-if="
              Number(detailsData.status) >= 5 &&
              Number(detailsData.status) <= 9
            "
            @click="handleTopicCode(detailsData)"
            type="text"
            >总检标</el-button
          >
          <el-button
            v-if="Number(detailsData.status) === 9"
            @click="handleBack(detailsData)"
            type="text"
            class="btn-back-wash"
            >返洗</el-button
          >
        </div>

        <el-tabs class="order-tabs" v-model="activeName">
          <el-tab-pane label="商品信息" name="0">
            <div class="tab-panel">
              <el-table
                :data="productTable"
                style="width: 100%"
                tooltip-effect="dark"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                  prop="productId"
                  label="商品ID"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="productCategory"
                  label="商品分类"
                ></el-table-column>
                <el-table-column
                  prop="productName"
                  label="商品名称"
                ></el-table-column>
                <el-table-column label="商品图片">
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.productPic"
                      width="80px"
                      height="60px"
                      :src="scope.row.productPic"
                    />
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="分项服务">
                  <template slot-scope="scope">
                    <el-tag
                      type="success"
                      v-for="(service, sIndex) in getServiceIds(
                        scope.row.addService,
                      )"
                      :key="sIndex"
                      >{{
                        `${service.name}￥${service.price.toFixed(2)}`
                      }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="addServiceAmount"
                  label="服务价格"
                ></el-table-column>
                <el-table-column
                  prop="originalAmount"
                  label="市场价格"
                ></el-table-column>
                <el-table-column
                  prop="memberAmount"
                  label="专属价格"
                ></el-table-column>
                <el-table-column
                  prop="payAmount"
                  label="实付价格"
                ></el-table-column>
                <el-table-column
                  prop="quantity"
                  label="数量"
                  width="100"
                ></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工单信息" name="1">
            <div class="tab-panel">
              <el-table
                :data="workTableData"
                style="width: 100%"
                tooltip-effect="dark"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column
                  type="index"
                  width="50"
                  label="#"
                ></el-table-column>
                <el-table-column
                  prop="orderSn"
                  label="订单编号"
                  width="160"
                ></el-table-column>
                <el-table-column label="工单类型">
                  <template slot-scope="scope">
                    <div>{{ workOrderStatus(scope.row.workType) }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="promoterMan"
                  label="发起人员"
                  width="120"
                ></el-table-column>
                <el-table-column label="优先级">
                  <template slot-scope="scope">
                    <el-tag type="primary" v-if="scope.row.priority == '1'"
                      >普通</el-tag
                    >
                    <el-tag type="danger" v-else-if="scope.row.priority == '2'"
                      >紧急</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column label="申请状态">
                  <template slot-scope="scope">
                    <el-tag type="primary" v-if="scope.row.status == '0'"
                      >待处理</el-tag
                    >
                    <el-tag type="success" v-else-if="scope.row.status == '2'"
                      >已完成</el-tag
                    >
                    <el-tag type="danger" v-else-if="scope.row.status == '3'"
                      >已拒绝</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="handleMan"
                  label="处理人员"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="modifyTime"
                  label="修改时间"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="handleNote"
                  label="处理备注"
                  width="150"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.row)"
                      type="primary"
                      >编辑</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!-- 大图预览 -->
    <div class="modal" v-if="showViewer">
      <el-image-viewer
        :on-close="closeViewer"
        :url-list="srcList"
        style="z-index: 9999"
      ></el-image-viewer>
    </div>
    <!-- 返洗弹框 -->
    <el-dialog
      custom-class="back-code-dialog"
      title="衣物返洗"
      :visible.sync="dialogVisibleBack"
      width="30%"
      center
    >
      <el-form
        :rules="rules"
        :model="washBack"
        ref="washBack"
        label-width="100px"
        size="small"
      >
        <el-form-item label="新条码:" prop="washingCode">
          <el-input
            placeholder="请输入新条码"
            v-model="washBack.washingCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="返洗原因:" prop="note">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入返洗原因"
            v-model="washBack.note"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBack = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleDialogBack" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 生成主水洗码 -->
    <WashedCode
      :parentCode="totalWashObj"
      :isWash="dialogWash"
      :printBy="printName"
      @child-event="handleEvent"
      ref="childComponent"
    ></WashedCode>
    <!-- 附水洗码 -->
    <AnnexCode
      :parentAnnex="totalWashObj"
      :isPrint="dialogAnnex"
      :printBy="printName"
      @child-annex="handleAnnex"
      ref="childAnnexRef"
    ></AnnexCode>
    <!-- 总检标 -->
    <topic-code
      :factoryName="printName"
      :stageDate="totalWashObj"
      @child-event="topicChange"
      @refreshOffline="refreshStage"
      ref="childTopic"
      v-if="dialogGenneral"
    ></topic-code>
    <!-- 工单详情页 -->
    <WorkDetail
      :visible.sync="workDialogVisible"
      :my-work="workObj"
    ></WorkDetail>
    <!-- 创建工单弹框 -->
    <CreateWork
      :key="workTimer"
      :my-object="detailsData"
      :isWork="2"
      :visible.sync="dialogVisibleOffline"
      @refreshWork="refreshParent"
    ></CreateWork>
    <!-- 父订单详情 -->
    <ParentOrderDetails
      :visible.sync="parentDialogVisible"
      :my-order="parentOrderObj"
      :select-list="serviceList"
    ></ParentOrderDetails>
  </div>
</template>

<script>
// 订单号获取工单、主订单号获取商品、通过订单编号获取订单附件,订单返洗,通过水洗码查询订单,取消总检,订单修改,订单修改(只修改状态)
import {
  orderWorkByOffline,
  orderProductOffline,
  annexOrderSnOffline,
  insertBackOrderOffline,
  getOrderByWashOffline,
  cancelGiById,
  updateOrderOffline,
  updateOrderOfflineStatus,
  listFileOffline,
  getOrderSnOffline,
  orderSnOfflineParent,
} from "@/api/store.js";
// 创建工单弹出框
import CreateWork from "@/components/work/CreateWork.vue";
import { getCookie } from "@/unit/cookie";
// 返回有效格架号、返回有效附件格架号,获取默认打印机名称
import {
  effectiveGrillage,
  effectiveGrillageFJ,
  printByType,
} from "@/api/setup.js";
// 处理工单弹出框
import WorkDetail from "@/components/order/WorkDetail.vue";
// 总检打印机
import TopicCode from "@/components/offline/topicCode.vue";
// 主
import WashedCode from "@/components/offline/washedCode.vue";
// 附水洗码打印机
import AnnexCode from "@/components/offline/annexCode.vue";
export default {
  name: "OrderDetails",
  components: {
    WorkDetail,
    TopicCode,
    AnnexCode,
    WashedCode,
    CreateWork,
    // 异步加载，避免与 ParentOrderDetails 互相引用形成循环依赖
    ParentOrderDetails: () =>
      import("@/components/offline/ParentOrderDetails.vue"),
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer.vue"),
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 传整个订单对象
    myOrder: {
      type: Object,
      default: () => ({}),
    },
    selectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      // 订单
      detailsData: this.myOrder,
      // 小程序商品信息
      productTable: [],
      // 工单信息
      workTableData: [],
      workObj: {}, //工单处理对象
      workDialogVisible: false,
      imageList: [], //衣物图片列表
      // 大图预览列表
      showViewer: false,
      srcList: [],
      isBackWash: false, //是否显示返洗按钮
      // 修改备注弹框
      dialogVisibleNote: false,
      washBackObj: {},
      dialogVisibleBack: false, //返洗弹框
      washBack: {
        washingCode: "", //新条码
        note: "", //返洗原因
      },
      // 表单规则
      rules: {
        washingCode: [
          { required: true, message: "请输入条码", trigger: "blur" },
          { validator: this.validateWashcode, trigger: "blur" },
        ],
        note: [{ required: true, message: "请输入返洗原因", trigger: "blur" }],
      },
      orderNote: "", //订单备注
      //日期选择器配置
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      printName: "", //打印机名称
      dialogWash: false, //主是否被点击
      dialogAnnex: false, //附是否被点击
      dialogGenneral: false, //总标是否点击打印
      totalWashObj: {},
      // 附件水洗码(补打)
      washFjData: [],
      dialogVisibleOffline: false,
      workTimer: "", //创建工单子组件只执行一次dom问题
      serviceList: [],
      detailDirty: false,
      loadSeq: 0,
      parentDialogVisible: false,
      parentOrderObj: {},
      activeName: "0",
    };
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      this.detailsData = { ...this.myOrder };
      this.serviceList = this.selectList;
      if (!newValue) {
        this.dialogAnnex = false;
        this.dialogGenneral = false;
        this.dialogWash = false;
        this.imageList = [];
        this.activeName = "0";
        this.$emit("refreshOrder", this.detailDirty);
        this.detailDirty = false;
        this.loadSeq += 1;
      } else {
        if (
          Number(this.detailsData.status) === 9 &&
          Number(this.detailsData.refundType) !== 1
        ) {
          this.isBackWash = true;
        }
        this.activeName = "0";
        this.detailDirty = false;
        const seq = ++this.loadSeq;
        this.$nextTick(() => {
          this.loadDetailData(seq);
        });
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    isLoadStale(seq) {
      return seq !== this.loadSeq;
    },
    async openParentOrderDetail() {
      const orderSn = this.detailsData.orderSnParent;
      if (!orderSn) {
        return;
      }
      try {
        const { data: res } = await orderSnOfflineParent(orderSn);
        if (Number(res.code) === 200 && res.data) {
          this.parentOrderObj = res.data;
          this.parentDialogVisible = true;
        } else {
          this.$message.error((res && res.message) || "未找到父订单");
        }
      } catch (err) {
        console.error(err);
        this.$message.error("查询父订单失败");
      }
    },
    async loadDetailData(seq) {
      if (this.isLoadStale(seq) || !this.detailsData.orderSn) {
        return;
      }
      await this.refreshOrderDetail(seq);
      if (this.isLoadStale(seq)) {
        return;
      }
      this.getOrderWork(this.detailsData.orderSn, seq);
      this.loadGarmentImages(this.detailsData, seq);
      this.getOrderProduct(this.detailsData, seq);
    },
    async refreshOrderDetail(seq) {
      try {
        const { data: res } = await getOrderSnOffline(this.detailsData.orderSn);
        if (this.isLoadStale(seq)) {
          return;
        }
        if (Number(res.code) === 200 && res.data) {
          this.detailsData = { ...this.detailsData, ...res.data };
        }
      } catch (err) {
        console.error(err);
      }
    },
    normalizeStatus(v) {
      if (v == null || v === "") {
        return null;
      }
      const n = Number(v);
      return Number.isNaN(n) ? v : n;
    },
    getImageFileName(url) {
      if (!url) {
        return "";
      }
      const path = String(url).split("?")[0];
      const segments = path.split("/");
      return segments[segments.length - 1] || path;
    },
    getImageSortKey(url) {
      const name = this.getImageFileName(url).replace(/\.[^.]+$/, "");
      if (name.length >= 20) {
        return name.slice(0, 8) + name.slice(12, 20);
      }
      return name;
    },
    sortImageList(list) {
      return [...list].sort(
        (a, b) =>
          this.getImageSortKey(a).localeCompare(this.getImageSortKey(b)) ||
          this.getImageFileName(a).localeCompare(this.getImageFileName(b)),
      );
    },
    parseProductPicField(productPic) {
      if (
        productPic == null ||
        productPic === "" ||
        productPic === "undefined"
      ) {
        return [];
      }
      return this.sortImageList(
        String(productPic)
          .split(",")
          .map((url) => url.split("?")[0])
          .filter(Boolean),
      );
    },
    markDetailDirty() {
      this.detailDirty = true;
    },
    // 判断字符串是否全部为数字
    isNumeric(str) {
      return /^\d+$/.test(str);
    },
    // 返洗水洗码自定义验证规则
    validateWashcode(rule, value, callback) {
      if (!this.isNumeric(value)) {
        callback(new Error("条码有误,只能为数字"));
      } else if (value.length < 8 || value.length > 12) {
        callback(new Error("条码为8-12位"));
      } else {
        callback();
      }
    },
    // 工单
    async getOrderWork(orderSn, seq) {
      this.workTableData = [];
      try {
        const { data: res } = await orderWorkByOffline(orderSn);
        if (this.isLoadStale(seq)) {
          return;
        }
        if (res.code === 200) {
          this.workTableData = res.data || [];
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getOrderProduct(data, seq) {
      this.productTable = [];
      if (!data || !data.paySn) {
        return;
      }
      try {
        const { data: res } = await orderProductOffline(data.paySn);
        if (this.isLoadStale(seq)) {
          return;
        }
        if (res.code === 200) {
          this.productTable = res.data || [];
        }
      } catch (err) {
        console.error(err);
      }
    },
    refreshParent(val) {
      this.dialogVisibleOffline = false;
      this.markDetailDirty();
      console.log("创建工单成功", val);
    },
    showImage(index) {
      this.showViewer = true;
      let tempImgList = [...this.imageList];
      let temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempImgList.shift());
      }
      this.srcList = tempImgList.concat(temp);
    },
    // 点击大图关闭
    closeViewer() {
      this.showViewer = false;
    },
    async loadGarmentImages(row, seq) {
      this.imageList = [];
      if (!row) {
        return;
      }
      if (row.ossFolderName) {
        try {
          const { data: res } = await listFileOffline(row.ossFolderName);
          if (this.isLoadStale(seq)) {
            return;
          }
          if (Number(res.code) === 200 && Array.isArray(res.data) && res.data.length) {
            this.imageList = this.sortImageList(
              res.data.map((url) => String(url).split("?")[0]).filter(Boolean),
            );
            return;
          }
        } catch (err) {
          console.error(err);
        }
        if (this.isLoadStale(seq)) {
          return;
        }
      }
      const directPics = this.parseProductPicField(row.productPic);
      if (!this.isLoadStale(seq) && directPics.length) {
        this.imageList = directPics;
      }
    },
    handleDelete(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.status = 10;
      this.$confirm("删单只修改衣物状态为已取消,退款请创建工单！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await updateOrderOffline(data);
            if (res.data && res.data.code === 200) {
              this.detailsData = { ...this.detailsData, ...data };
              this.markDetailDirty();
              this.dialogVisibleOffline = true;
              this.$message.success("删单成功!");
            } else {
              this.$message.error(
                (res.data && res.data.message) || "删单失败",
              );
            }
          } catch (err) {
            console.error(err);
            this.$message.error("删单失败，请稍后重试");
          }
        })
        .catch(() => {});
    },
    // 订单提前完成
    handleCompleted(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.status = 9;
      this.$confirm("是否提前完成订单！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await updateOrderOffline(data);
            if (res.data && res.data.code === 200) {
              this.detailsData = {
                ...this.detailsData,
                ...(res.data.data || data),
              };
              this.markDetailDirty();
              this.$message.success("操作成功!");
            } else {
              this.$message.error(
                (res.data && res.data.message) || "操作失败",
              );
            }
          } catch (err) {
            console.error(err);
            this.$message.error("操作失败，请稍后重试");
          }
        })
        .catch(() => {});
    },
    // 取消总检
    handleCancelGiBy(row) {
      this.$confirm("是否取消该衣物总检", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await cancelGiById(row.id);
            if (res.data && res.data.code === 200) {
              this.detailsData = {
                ...this.detailsData,
                ...(res.data.data || {}),
                status:
                  (res.data.data && res.data.data.status != null
                    ? res.data.data.status
                    : 4),
              };
              this.markDetailDirty();
              this.$message.success("衣物取消总检成功!");
            } else {
              this.$message.error(
                (res.data && res.data.message) || "取消总检失败",
              );
            }
          } catch (err) {
            console.error(err);
            this.$message.error("取消总检失败，请稍后重试");
          }
        })
        .catch(() => {});
    },
    async ensurePrintName(type) {
      try {
        const printObj = {
          printFactoryId: Number(getCookie("factoryId")),
          printType: type,
        };
        const { data: res } = await printByType(printObj);
        if (res.code === 200 && res.data && res.data.printName) {
          this.printName = res.data.printName;
          return this.printName;
        }
        this.$message.error("未获取到打印机名称");
        return "";
      } catch (err) {
        console.error(err);
        this.$message.error("获取打印机失败，请稍后重试");
        return "";
      }
    },
    // 补打主水洗码
    async handleWashCode(row) {
      const printName = await this.ensurePrintName(1);
      if (!printName) {
        return;
      }
      this.totalWashObj = { ...row, printName };
      this.dialogWash = true;
      this.$emit("washed-code", this.totalWashObj);
      await this.$nextTick();
      if (this.$refs.childComponent) {
        this.$refs.childComponent.printWashCode();
      }
    },
    // event条码码子组件
    handleEvent(res) {
      // console.log('event', res)
    },
    handleAnnex(res) {},
    // 补打附水洗码
    async handleAnnexCode(row) {
      if (!row.productAnnex) {
        return;
      }
      const printName = await this.ensurePrintName(1);
      if (!printName) {
        return;
      }
      await this.getAnnexList(row.orderSn);
      if (this.washFjData.length != 0) {
        this.totalWashObj = { ...row, annexCode: this.washFjData, printName };
        this.dialogAnnex = true;
        this.$emit("child-annex", this.totalWashObj);
        await this.$nextTick();
        if (this.$refs.childAnnexRef) {
          this.$refs.childAnnexRef.printAnnex();
        }
      } else {
        this.$message.warning("未获取到附件水洗码");
      }
    },
    topicChange(data) {
      console.log("总检");
    },
    refreshStage() {
      this.dialogGenneral = false;
    },
    // 补打总检标
    async handleTopicCode(row) {
      const printName = await this.ensurePrintName(2);
      if (!printName) {
        return;
      }
      this.totalWashObj = { ...row, printName };
      this.dialogGenneral = true;
      this.$emit("child-event", this.totalWashObj);
      await this.$nextTick();
      if (this.$refs.childTopic) {
        this.$refs.childTopic.print();
      }
    },
    // 返洗确定按钮
    handleDialogBack() {
      this.$refs.washBack.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.washBackObj));
        data.washingCode = this.washBack.washingCode;
        data.note = this.washBack.note;
        data.id = "";
        data.wxAmount = 0;
        data.balancelAmount = 0;
        data.payAmount = 0;
        data.parentOrderSn = this.washBackObj.orderSn;
        try {
          const res = await getOrderByWashOffline(this.washBack.washingCode);
          const obj = res.data.data;
          if (res.data.code !== 200) {
            this.$message.error(res.data.message || "条码校验失败");
            return;
          }
          if (obj) {
            this.$message.error("重复水洗码请重新输入！");
            return;
          }
          const back = await insertBackOrderOffline(data);
          if (back.data && back.data.code === 200) {
            this.washBack.washingCode = "";
            this.washBack.note = "";
            this.markDetailDirty();
            this.$message.success("返洗单创建成功！");
            this.dialogVisibleBack = false;
          } else {
            this.$message.error(
              (back.data && back.data.message) || "返洗单创建失败",
            );
          }
        } catch (err) {
          console.error(err);
          this.$message.error("返洗单创建失败，请稍后重试");
        }
      });
    },
    // 返洗
    handleBack(data) {
      this.dialogVisibleBack = true;
      this.washBackObj = data;
      console.log("返洗", data);
    },
    // 通过订单编号获取订单附件水洗码
    async getAnnexList(orderSn) {
      this.washFjData = [];
      const { data: res } = await annexOrderSnOffline(orderSn);
      if (res.code === 200) {
        let arr = res.data;
        //为真就获取子项附件水洗码，为假返回整个子项的附件
        if (arr.length > 0) {
          arr.forEach((item) => {
            this.washFjData.push(item.washingCode);
          });
        }
      }
    },
    // 查询默认打印机名称
    getPrint(type) {
      this.ensurePrintName(type);
    },
    // 工单编辑操作
    handleEdit(row) {
      this.workDialogVisible = true;
      this.workObj = row;
      console.log("work", this.workObj, this.workDialogVisible);
    },
    isContentShort(str) {
      return !str || String(str).length <= 20;
    },
    // 回显分项服务
    getServiceIds(ids) {
      const serviceIds = ids ? ids.split(",").map(Number) : [];
      let filter = this.serviceList.filter((items) =>
        serviceIds.includes(items.id),
      );
      console.log("ids", filter, serviceIds);
      return filter;
    },
    // 订单状态
    orderStatus(v) {
      const status = this.normalizeStatus(v);
      //状态:0->已付款；1->待送件；2->已收衣（门店）；3->已取件（物流）；4->已分检；5->已总检;6->已出库；7->净衣到店（物流）；8->净衣入库（门店）；9->完成；10->取消；11->已拒单
      switch (status) {
        case 0:
          return "已付款";
        case 1:
          return "待送件";
        case 2:
          return "门店已收衣";
        case 3:
          return "已取件(物流)";
        case 4:
          return "已分检";
        case 5:
          return "已总检";
        case 6:
          return "已出库(在途)";
        case 7:
          return "已到店";
        case 8:
          return "已入库";
        case 9:
          return "已完成(已取衣)";
        case 10:
          return "已取消";
        case 11:
          return "已拒单";
        default:
          return "";
      }
    },
    // 取消
    // toNext() {
    //   this.dialogVisible = false;
    // },
    // 工单类型
    workOrderStatus(v) {
      //类型:1->订单异常；2->售后；3->漏补发；4->催单；5->投诉；6->个人业务；7->疑似丢件；8->退款
      switch (v) {
        case 1:
          return "订单异常";
        case 2:
          return "售后";
        case 3:
          return "漏补发";
        case 4:
          return "催单";
        case 5:
          return "投诉";
        case 6:
          return "个人业务";
        case 7:
          return "疑似丢件";
        case 8:
          return "退款";
        case 9:
          return "数量不符";
        case 10:
          return "补款";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped lang="less">
.orderDetails {
  /deep/ .order-dialog {
    margin-top: 4vh !important;
    border-radius: 10px;
    overflow: hidden;

    .el-dialog__header {
      padding: 16px 24px 12px;
      border-bottom: 1px solid #ebeef5;
      background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
    }

    .el-dialog__body {
      padding: 0;
      max-height: calc(92vh - 60px);
      overflow-y: auto;
      background: #f5f7fa;
    }
  }

  /deep/ .back-code-dialog {
    height: 320px !important;
    margin-top: 200px !important;

    .el-dialog__body {
      padding: 10px 25px 0;

      .el-input__inner {
        width: 230px;
      }
    }
  }
}

.order-dialog__title-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.order-dialog__back-icon {
  color: #f56c6c;
  font-size: 20px;
}

.order-dialog__refund-icon {
  color: #737272;
  font-size: 20px;
}

.order-dialog__sn {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}

.order-detail-body {
  padding: 16px 20px 20px;
}

.order-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 14px 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  &__item {
    flex: 1;
    min-width: 120px;
    text-align: center;
    padding: 4px 8px;

    &:not(:last-child) {
      border-right: 1px solid #f0f2f5;
    }
  }

  &__label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 16px;
    font-weight: 600;
    color: #303133;

    &--primary {
      color: #409eff;
      font-size: 18px;
    }
  }
}

.detail-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
}

.detail-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  overflow: hidden;

  &--full {
    grid-column: 1 / -1;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #fafbfc;
    border-bottom: 1px solid #f0f2f5;
  }

  &__icon {
    font-size: 16px;
    color: #409eff;

    &--money {
      color: #e6a23c;
    }

    &--cloth {
      color: #909399;
    }

    &--logistics {
      color: #67c23a;
    }
  }

  &__title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  &__body {
    padding: 12px 14px;
  }
}

.detail-btn {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
}

.btn-danger-text {
  color: #f56c6c;
}

.btn-back-wash {
  color: #f56c6c;
  font-size: 16px;
}

.order-tabs {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 0 12px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }

  /deep/ .el-tabs__item {
    font-weight: 500;
    height: 44px;
    line-height: 44px;
  }

  /deep/ .el-tabs__item.is-active {
    font-weight: 600;
    color: #409eff;
  }
}

.tab-panel {
  padding-top: 12px;
}

.cloth-imgs {
  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__item {
    width: 56px;
    height: 56px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ebeef5;
    cursor: zoom-in;
    background: #f5f7fa;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__empty {
    color: #909399;
    font-size: 13px;
  }
}

.link-sn {
  color: var(--theme-primary, #409eff);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.text-danger {
  color: #f56c6c;
}

.ellipsis {
  max-width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/deep/ .el-image-viewer__wrapper {
  z-index: 9999 !important;
}

/deep/ .el-table__fixed-right::before {
  content: none;
}

@media (max-width: 992px) {
  .detail-cards {
    grid-template-columns: 1fr;
  }

  .detail-section--full {
    grid-column: auto;
  }

  .order-summary__item:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid #f0f2f5;
    padding-bottom: 8px;
  }
}
</style>
